import React, { FC } from 'react';
import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import Button from 'vibo-ui/Button';
import EventPeople from 'components/events/EventPeople';

import { PEOPLE_TO_SHOW } from './constants';
import { useTimeline } from 'components/events/Timeline/TimelineContext';

import { GET_EVENT_CONTACTS } from 'graphql/queries/events';

import { IconmoonFont } from 'vibo-ui/Icon';
import { EventUserType } from 'types/enums';

const HostsGuests: FC = () => {
  const { t } = useTranslation();

  const { variables } = useTimeline();

  const { data } = useQuery<GetEventContacts>(GET_EVENT_CONTACTS, {
    variables: {
      eventId: variables.eventId,
    },
    fetchPolicy: 'cache-and-network',
  });
  const contacts = data?.eventContacts.contacts || [];

  return (
    <EventPeople
      people={[...contacts].sort((a, b) => {
        if (a.role === b.role) return 0;
        return a.role === EventUserType.host ? -1 : 1;
      })}
    >
      {contacts.length > PEOPLE_TO_SHOW ? (
        <Button
          to={`/event/${variables.eventId}/users`}
          subText={t('allAmount', { count: contacts.length })}
          prefixIcon={IconmoonFont['publicOutline-24']}
          displayType="blueBorder"
          shape="circle"
          size="xxl"
        />
      ) : null}
    </EventPeople>
  );
};

export default HostsGuests;
